import { Redirect } from "expo-router";

import SeoHead from "@/components/seo/SeoHead";
import {
  SEO_DEFAULT_IMAGE_URL,
  SEO_HOME_DESCRIPTION,
  SEO_HOME_TITLE,
  buildCanonicalUrl,
  buildOrganizationJsonLd,
  buildWebSiteJsonLd,
} from "@/lib/seo";

export default function Index() {
  return (
    <>
      <SeoHead
        title={SEO_HOME_TITLE}
        description={SEO_HOME_DESCRIPTION}
        canonicalUrl={buildCanonicalUrl("/")}
        imageUrl={SEO_DEFAULT_IMAGE_URL}
        jsonLd={[buildOrganizationJsonLd(), buildWebSiteJsonLd()]}
      />
      <Redirect href={{ pathname: "/directory" }} />
    </>
  );
}
